import { render, staticRenderFns } from "./BetTransactionItem.vue?vue&type=template&id=bd92d44a"
import script from "./BetTransactionItem.vue?vue&type=script&lang=ts"
export * from "./BetTransactionItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports